import axios from "axios"
import { URL } from "./settings"

export class AuthService {
    static async token(data) {
        try {
            const response = await axios.post(`${URL}/auth/login/token`, data, {
                withCredentials: true
            })
            console.log("AuthService::auth response", response)
            return response
        } catch (error) {
            console.log(error)
            return error.response
        }
    }

    static async logout() {
        try {
            const response = await axios.post(`${URL}/auth/logout`, {}, {
                withCredentials: true
            })
            console.log("AuthService::logout response", response)
            return response
        } catch (error) {
            console.log(error)
            return error.response
        }
    }
}
